<template>
  <div class="contest-detail">
    <div class="detail-poster">
      <img :src="detail.banner" />
    </div>
    <div class="menu">
      <div class="menu-box">
        <div
          class="menu-item"
          :class="menu_type == 'match_introduction' ? 'active' : ''"
          @click="onMenuClick('match_introduction')"
        >
          大赛简介
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'design_introduction' ? 'active' : ''"
          @click="onMenuClick('design_introduction')"
        >
          组织架构
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'about_organizer' ? 'active' : ''"
          @click="onMenuClick('about_organizer')"
        >
          赛事亮点
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'match_instructions' ? 'active' : ''"
          @click="onMenuClick('match_instructions')"
        >
          赛程安排
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'match_information' ? 'active' : ''"
          @click="onMenuClick('match_information')"
        >
          奖项设置
        </div>
        <div
          v-if="detail.open_rank === 1"
          class="menu-item"
          :class="menu_type == 'vote_ranking' ? 'active' : ''"
          @click="onMenuClick('vote_ranking')"
        >
          投票排行榜
        </div>
        <div
          v-if="detail.open_rank === 1"
          class="menu-item"
          :class="menu_type == 'award_announcement' ? 'active' : ''"
          @click="onMenuClick('award_announcement')"
        >
          获奖公示
        </div>
        <!-- <div
          class="menu-item"
          :class="menu_type == 'entries' ? 'active' : ''"
          @click="onMenuClick('entries')"
        >
          参赛作品
        </div> -->
      </div>
      <div class="btn-box" v-if="detail.allow_signup == 1">
        <div v-if="canSignIn" class="sign-in-btn" @click="onSignIn">
          <img src="../../assets/images/icon-sign-in-match.png" />
          {{ detail.is_signin ? '已报名' : '在线报名' }}
        </div>
        <div v-if="canUpload" class="upload-btn" @click="onUploadClick">
          <img src="../../assets/images/icon-upload-match.png" />
          <!-- (detail.is_upload.status != 3 ?'查看作品':'编辑作品') -->
          {{ detail.is_upload.match_uuid ? '查看作品' :'上传作品' }}
        </div>
      </div>
    </div>
    <div :class="['content',{'not-full':detail.detail_full == 2}]">
      <!-- <div v-if="menu_type != 'entries' && !show_upload" class="content-title">
        —— {{ menu_type | menu_type }} ——
      </div> -->
      <div v-if="menu_type == 'entries'" class="content-title-list">
        全部作品<span>({{posts_list.length}})</span>
      </div>
      <!-- style="margin-top: 75px" -->

      <!--  match_introduction / 大赛简介,design_introduction / 设计说明 ,about_organizer / 关于主办方,match_instructions / 参赛须知,match_information / 参赛资料 -->
      <div v-if="['match_introduction', 'design_introduction', 'about_organizer', 'match_instructions', 'match_information'].includes(menu_type) && !show_upload" class="all-content">
        <div ref='match_introduction' id="match_introduction"
          v-html="detail.match_introduction"
        ></div>
        <div ref='design_introduction' id="design_introduction"
          v-html="detail.design_introduction"
        ></div>
        <div ref='about_organizer' id="about_organizer"
          v-html="detail.about_organizer"
        ></div>
        <div ref='match_instructions' id="match_instructions"
          v-html="detail.match_instructions"
        ></div>
        <div ref='match_information' id="match_information"
          v-html="detail.match_information"
        ></div>
      </div>
      <VoteRanking v-if="menu_type === 'vote_ranking'" :uuid="uuid" />
      <div v-if="menu_type == 'award_announcement'" v-html="detail.award_announcement_pc" class="all-content"></div>
      <!-- 瀑布流 -->
      <div
        v-if="false"
        class="masonry-container"
        style="margin-top: 30px; padding-bottom: 70px"
      >
        <masonry
          :cols="{ default: 4, 1000: 4, 700: 3, 400: 2 }"
          :gutter="{ default: '20px', 1000: '20px', 700: '15px', 400: '10px' }"
        >
          <div
            v-for="(item, index) in posts_list"
            :key="index"
            @click="onWorksItemClick(item)"
          >
            <template>
              <div class="masonry-item">
                <img
                  :src="item.cover | default_img"
                  @load="onImageLoad"
                  class="masonry-image"
                />
                <div class="item-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="center-box">
                    <div class="center-items">
                      <img
                        src="../../assets/images/icon-views-contest.png"
                        alt=""
                      />{{ item.view_times }}
                    </div>
                    <div class="center-items">
                      <img
                        src="../../assets/images/icon-comment-contest.png"
                        alt=""
                      />{{item.comment_count}}
                    </div>
                    <div class="center-items">
                      <img
                        src="../../assets/images/icon-like-contest.png"
                        alt=""
                      />{{item.zan_count}}
                    </div>
                  </div>
                  <div class="bottom-box">
                    <div class="nick-avatar">
                      <img
                        class="avatar"
                        :src="item.member.avatar | default_img"
                      />
                      <div class="nick">
                        {{ item.member.nickname || item.member.username }}
                      </div>
                    </div>
                    <!-- <div class="like-box">
                                            <img src="../../assets/images/icon-like.png" style="width:16px;height:16px;" />
                                            <div style="margin-left:3px;">{{item.collect_count}}</div>
                                        </div> -->
                  </div>
                  <!-- <p>{{ item.description }}</p> -->
                </div>
              </div>
            </template>
          </div>
        </masonry>
      </div>
    </div>
    <SignIn v-if="show_sign_in" @on-close="onCloseSignIn" :uuid="uuid" :commitments="signCommitments" :custom_field="signCustomField"></SignIn>
    <ArticleDetail ref="articleDetail" v-if="show_detail" @on-close="onCloseArticleDetail" :uuid="post_uuid" :postType="2"></ArticleDetail>
    <SideMenu :mainClass="sideMenuClass" :shareUrl="shareUrl" :is-work-weixin="true"></SideMenu>
    <SubmitResult v-if="show_result" @close="onCloseSubmitResult" @confirm="onSubmitResultConfirm" @apply="onApply"></SubmitResult>
    <SubmitWorks v-if="show_upload" :detail="detail" :matchUUID="uuid" :formData="form" @close="onCloseSubmitWorks" @confirm="onSubmitWorksConfirm"></SubmitWorks>
  </div>
</template>
<script>
import {
  addUserContribution, SaveDraft
} from "@/api/index";
import { GetMatchDetail, MatchPostsList, MatchPostsUpload, MatchSignInCheck } from "@/api/social";
import ArticleDetail from '@/components/ArticleDetail';
import SideMenu from '@/components/SideMenu/SideMenu';
import { uploadFileToOSS } from '@/utils/oss';
import { mapState } from 'vuex';
import SignIn from "./components/SignIn";
import SubmitResult from './components/SubmitResult';
import SubmitWorks from "./components/SubmitWorks.vue";
import VoteRanking from "./components/VoteRanking.vue";
export default {
  components: {
    SignIn,ArticleDetail,SideMenu,SubmitResult,SubmitWorks, VoteRanking,
  },
  data() {
    return {
      menu_type: "match_introduction",
      posts_list: [],
      detail: {},
      show_sign_in: false,
      show_upload: false,
      form: {
        title: "",
        image_list: [],
        content: "",
        is_agree:false,
        custom_field:[]
      },
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      uuid:'',
      show_detail:false,
      post_uuid:'',
      is_signin:'',
      observer: null,
      isScrolling: false,
      scrollTimer: null,
      timeInterval:null,
      readTime:0,
      show_result:false
    };
  },
  computed:{
     ...mapState(['taskSetting','userInfo']),
    is_login(){
      return this.$store.state.is_login;
    },
    canUpload(){
      const { status, match_time,is_signin,is_upload } = this.detail;

      //>状态不在可上传状态
      // if(status != 2){
      //   return false;
      // }

      if(!is_signin){
        return false;
      }

      // 将 match_time 转换为 Date 对象并比较当前时间
      const matchTimeDate = new Date(match_time);
      const now = new Date();

      // 判断是否超过了 match_time
      if (now > matchTimeDate && !is_upload.match_uuid) {
        return false;
      }

      return true;
    },
    canSignIn(){

      const { status, sign_time } = this.detail;

      // if(status != 1){
      //   return false;
      // }

      // 将 match_time 转换为 Date 对象并比较当前时间
      const matchTimeDate = new Date(sign_time);
      const now = new Date();

      // 判断是否超过了 match_time
      if (now > matchTimeDate) {
        return false;
      }

      return true;
    },
    signCommitments() {
      if(!this.detail.commitments) {
        return []
      }
      return this.detail.commitments.filter((i)=>{
        return i.use_type== 'sign'
      })
    },
    signCustomField() {
      if(!this.detail.custom_field) {
        return []
      }
       return this.detail.custom_field.filter((i)=>{
        return i.use_type== 'sign'
      })
    },
    uploadCommitments() {
      if(!this.detail.commitments) {
        return []
      }
       return this.detail.commitments.filter((i)=>{
        return i.use_type== 'upload'
      })
    },
    sideMenuClass(){
      return `position: fixed;
              bottom: 100px;
              right: 0px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              z-index:119;
              `
    },
    shareUrl() {
      let url = `${window.location.origin}/contest/detail?uuid=${this.uuid}`;
      return url
    },


  },
  filters: {
    menu_type(type) {
      switch (type) {
        case "match_introduction":
          return "大赛简介";
        case "design_introduction":
          return "组织架构";
        case "about_organizer":
          return "赛事亮点";
        case "match_instructions":
          return "赛程安排";
        case "match_information":
          return "奖项设置";
        case "vote-ranking":
          return "投票排行榜";
        case "entries":
          return "参赛作品";
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  mounted() {
    let { uuid } = this.$route.params;
    if(this.$route.query.uuid) {
      uuid = this.$route.query.uuid
    }
    if (!uuid) {
      console.log("uuid is null");
      history.back();
      return;
    }
    //console.log('post_uuid',post_uuid)
    // if(post_uuid){
    //   this.post_uuid = post_uuid;
    //   this.show_detail = true;
    // }
    this.uuid = uuid;
    this.onGetDetail();
    this.onGetPostsList();
    // if(this.is_login){
    //   this.onSiginCheck();
    // }

    if(this.$route.query.code && this.$route.query.code != this.userInfo.code) {
      addUserContribution({
        uuid: this.uuid,
        code:this.$route.query.code,
        action_type:'matchShare'
      })
    }
    this.timeInterval = setInterval(() => {
      this.readTime++
    }, 1000);
    this.$nextTick(() => {
      this.initIntersectionObserver();
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    clearInterval(this.timeInterval)
  },
  watch: {
      readTime(value) {
          if(value >= this.taskSetting?.matchRead?.needTime && this.is_login) {
              addUserContribution({
                  uuid: this.uuid,
                  user_id:this.userInfo.id,
                  action_type:'matchRead'
              })
              clearInterval(this.timeInterval)
              this.readTime = 0
          }
      }
  },
  methods: {
    onSubmitWorksConfirm(data){
      console.log('data',data);
      this.form.image_list = data.image_list;
      this.show_upload = false;
      this.show_result = true;
    },
    onCloseSubmitWorks(){
      this.show_upload = false;
    },
    async onSubmitResultConfirm(){
      if(!this.form.image_list || !this.form.image_list.length){
        this.$layer.msg('请完善作品图片');
        return;
      }
      const {data} = await SaveDraft({image_list:this.form.image_list,scene:'bc'});
      if(!data.uuid){
        this.$layer.msg('操作失败,请稍后重试~');
        return;
      }
      this.$layer.msg('操作成功,即将跳转样衣定制~');
      setTimeout(()=>{
        this.show_result = false;
        // this.$refs['up_form'].resetFields();
        this.form.image_list = [];
        this.$router.push({name:"WorkBenchDesign",query:{uuid:data.uuid,from:'draft'}});
      },500)
    },
    onApply(){
      this.show_result = false;
      this.$router.push({name:"ContestSampleApply",query:{uuid:this.uuid}});
    },
    onCloseSubmitResult(){
      // this.$refs['up_form'].resetFields();
      this.form.image_list = [];
      this.show_result = false;
      window.location.reload();
    },
    removeImg(index){
      this.form.image_list.splice(index,1)
    },
    handleChange(e,index) {
      this.form.custom_field[index].value = e
    },
    beforeUpload(file, index) {
      this.uploadSectionFile(file, index)
      return false
    },
    async uploadSectionFile(file, index) {
        const url = await uploadFileToOSS(file, 'template')
        if(index === 'img_list'){
          this.form.image_list.push(url);
        }else{
          this.form.custom_field[index].value = url
          this.form.custom_field[index].fileName = file.name
        }
    },
    async onSiginCheck(){
      const {data} = await MatchSignInCheck({uuid:this.uuid});
      if(data.is_signin){
          this.is_signin = true;
          return;
      }
    },
    onSignIn() {
      if(!this.is_login) {
        this.$layer.msg("请先登录");
        this.$router.push({name:"Login",query:{back_params:JSON.stringify({uuid:this.uuid}),back_name:'ContestDetail'}});
        return;
      }

      if(!this.canSignIn){
        this.$layer.msg("已过报名时间或比赛已结束");
        return;
      }

      if(this.detail.is_signin){
        this.$layer.msg('您已报名');
        return;
      }

      this.show_sign_in = true;
    },
    onCloseArticleDetail(e){
      console.log('关闭弹窗');
      this.show_detail = false;
    },
    async onGetPostsList(){
        try{
            const {data} = await MatchPostsList({uuid:this.uuid});
            this.posts_list = data;
        }catch(e){
            console.log('e-list',e);
            this.$layer.msg(e.msg);
        }
    },
    onMenuClick(menu){
        this.menu_type = menu;
        this.show_upload = false;

         // 设置滚动状态，防止观察器干扰
         this.isScrolling = true;
        if (this.scrollTimer) {
          clearTimeout(this.scrollTimer);
        }

          // 锚点跳转
          if (menu !== 'entries') {
          this.$nextTick(() => {
            const element = this.$refs[menu];
            if (element) {
              const headerOffset = 80;
              const elementPosition = element.offsetTop;
              const offsetPosition = elementPosition - headerOffset;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          });
        }

        // 滚动结束后重新启用观察器
        this.scrollTimer = setTimeout(() => {
          this.isScrolling = false;
        }, 1000);
    },

    initIntersectionObserver() {
       // 创建交叉观察器
       this.observer = new IntersectionObserver((entries) => {
        // 如果正在滚动，不执行自动切换
        if (this.isScrolling) return;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 获取当前进入视口的元素ID
            const id = entry.target.id;
            // 根据ID设置当前激活的菜单项
            switch (id) {
              case 'match_introduction':
                this.menu_type = 'match_introduction';
                break;
              case 'design_introduction':
                this.menu_type = 'design_introduction';
                break;
              case 'about_organizer':
                this.menu_type = 'about_organizer';
                break;
              case 'match_instructions':
                this.menu_type = 'match_instructions';
                break;
              case 'match_information':
                this.menu_type = 'match_information';
                break;
            }
          }
        });
      }, {
        // 设置交叉观察器的选项
        root: null, // 使用视口作为根
        rootMargin: '-20% 0px -80% 0px', // 上边缘距离20%，下边缘距离80%时触发
        threshold: 0 // 任何部分交叉都会触发
      });

      // 观察所有内容区域
      this.$nextTick(() => {
        if (this.$refs.match_introduction) {
          this.observer.observe(this.$refs.match_introduction);
        }
        if (this.$refs.design_introduction) {
          this.observer.observe(this.$refs.design_introduction);
        }
        if (this.$refs.about_organizer) {
          this.observer.observe(this.$refs.about_organizer);
        }
        if (this.$refs.match_instructions) {
          this.observer.observe(this.$refs.match_instructions);
        }
        if (this.$refs.match_information) {
          this.observer.observe(this.$refs.match_information);
        }
      });
    },
    async onPostsSubmit(){
        try{
          // console.log('this.form',this.form);
            if(this.form.uuid && this.form.status == 2){
              this.$layer.msg("当前作品已经审核完成,无法再次更改")
              return;
            }
          // return;
            const {is_agree,title,image_list,content} = this.form;
            if(!is_agree){
                this.$layer.msg('请先同意规则');
                return;
            }
            if(!title || !image_list.length || !content){
                this.$layer.msg("请填写完整信息");
                return;
            }
            let msg = ''
            this.form.custom_field.forEach((i)=>{
                if(i.is_required && !i.value) {
                    msg = i.name + '必填'
                }
            })
            if(msg) {
                this.$layer.msg(msg);
                return;
            }
            const param = this.form;
            param.match_uuid = this.uuid;
            console.log('param===',param);
            // const {data} = 
            await MatchPostsUpload(param); 
            // console.log('data',data);
            // this.$layer.msg('上传成功,请耐心等待审核');
            // this.$refs['up_form'].resetFields();
            // this.form.image_list = [];
            this.show_result = true;
            // window.location.reload();
            // this.$router.push({name:'Posts',params:{uuid:data.post_uuid}});
        }catch(e){
            console.log('e-upload-e',e);
            this.$layer.msg(e.msg);
        }
    },
    handleSuccess(response, file, fileList, field) {
      const length = this.form.image_list.length;
      if (length > 18) {
        this.$layer.msg("最多上传18张图片");
        return;
      }
      if (field === "img_list") {
        this.form.image_list.push(response.data.url);
      }
    },
    async onUploadClick() {
        try{
          if(!this.canUpload){
            this.$layer.msg("已过报名时间或比赛已结束");
            return;
          }
            const {data} = await MatchSignInCheck({uuid:this.uuid});
            console.log('data',data);
            if(!data.is_signin){
                this.$layer.msg('请先报名比赛');
                return;
            }
            const {is_upload} = this.detail;
        //     title: "",
        // image_list: [],
        // content: "",
        // is_agree:false,
        // custom_field:[]
            // const {uuid,status,content,cover,image_list,custom_field,title} = is_upload;
            console.log('is_upload',is_upload);
            // && is_upload.status != 3
            if(is_upload.uuid){
              if(is_upload.length>0 || is_upload.uuid){
                await this.$set(this,'form',is_upload);
              }
              // await localStorage.setItem('match_upload',JSON.stringify({...is_upload,match_uuid:this.uuid}));
              this.$router.push({name:'WorksDetail',query:{uuid:is_upload.uuid}});
              return;
            }
            // this.form = {...is_upload,match_uuid:this.uuid}
            console.log('this.form',this.form);
            this.show_upload = true;
            this.menu_type = 'match_introduction';
        }catch(e){
            console.log('e-sign-in-e',e);
            this.$layer.msg(e.msg);
        }
    },
    onCloseSignIn(data) {
      if(data){
        this.onGetDetail();
      }
      this.show_sign_in = false;
    },
    async onGetDetail() {
      try {
        const { data } = await GetMatchDetail({ uuid: this.uuid });
        console.log("data----", data);
        this.detail = data;
        // console.log('is_upload',data.is_upload,data.is_upload.match_uuid);
        this.form.custom_field = this.detail.custom_field.filter((i)=>{
          return i.use_type== 'upload'
        })
        // 确保 checkbox 类型的字段 value 初始化为数组而不是空字符串
        this.form.custom_field.forEach((field) => {
          if (field.type === 'checkbox' && (!field.value || typeof field.value === 'string')) {
            this.$set(field, 'value', []);
          }
        })
      } catch (e) {
        console.log("eee-", e);
      }
    },
    onWorksItemClick(item) {
      console.log("item", item);
      this.post_uuid = item.uuid;
      this.show_detail = true;
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    toCommitment(id) {
        const uri = `${window.location.origin}/commitment?id=${id}`;
        window.open(uri, "_blank");
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./contestdetail.scss";
</style>
